import React from 'react';
import {useSearchParams} from 'react-router-dom';
import {OnboardingFeatures} from '../../components/onboarding-features';
import {OnboardingForm} from '../../components/onboarding-form';
import {Grid} from '../../components/layout';

export const OnboardingPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const referralCode = searchParams.get('ref') || undefined;

  return (
    <Grid cols={{sm: 1, lg: 2}}>
      <OnboardingFeatures />
      <OnboardingForm referralCode={referralCode} />
    </Grid>
  );
};
